import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Kode Penutupan', value: 'code' },
  { text: 'Kategori', value: 'category_label' },
  { text: 'Deskripsi', value: 'description' },
  { text: 'Status', value: 'status_label' },
  { text: 'Action', value: 'action', width: '10' },
]);

export const search = {
  code: '',
  category: '',
  description: '',
  status: '',
};

export const categoryOptions = [
  { text: 'Normal', value: 1 },
  { text: 'Abnormal', value: 2 },
];

export const statusOptions = [
  { text: 'Aktif', value: 1 },
  { text: 'Tidak Aktif', value: 2 },
];
